import { createDomain } from 'effector-root';

const domain = createDomain('PrintMode (Page)');

export const onPageStarted = domain.event();